//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';

export default {
  name: 'Sessie',
  props: {
    expert: String,
    ajax: String,
    id: '',
    handleEdit: Function,
  },
  data: function () {
    return {
      loading: true,
      title: '',
      price: '',
      type: '',
      content: '',
      leerdoelen: '',
      doelgroep: '',
      language: '',
      excerpt: '',
      topic: '',
      expertises: [],
      option_language: [
        { value: 'nl', label: 'Nederlands' },
        { value: 'gb', label: 'Engels' },
        { value: 'de', label: 'Duits' },
        { value: 'es', label: 'Spaans' },
      ],
      permalink: '',
      thumbnail: '',
      youtube: '',
      max_participants: 10,
    };
  },
  methods: {
    load: function () {
      this.loading = true;

      const self = this;
      axios.get(`${this.ajax}?action=sessie&id=${this.id}`).then(res => {
        const sessie = res.data;

        self.title = sessie.title;
        self.price = sessie.price;
        self.type = sessie.type;
        self.content = sessie.content;
        self.leerdoelen = sessie.leerdoelen;
        self.doelgroep = sessie.doelgroep;
        self.language = sessie.language;
        self.excerpt = sessie.excerpt;
        self.topic = sessie.topic;
        self.expertises = sessie.expertises;
        self.permalink = sessie.permalink;
        self.thumbnail = sessie.thumbnail;
        self.youtube = sessie.youtube;
        self.max_participants = sessie.max_participants;

        self.loading = false;
      }).catch(error => {
        console.log(error);
        self.loading = true;
      });
    },
    clickEdit: function () {
      this.handleEdit(this.id);
    },
  },
  watch: {
    id: function () {
      this.load();
    },
  },
  created: function () {
    this.load();
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/Sessies/Sessie.vue